import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/kit";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Monitor, ExternalLink } from "lucide-react";

export default function WallDisplayAdmin() {
  const [branches, setBranches] = useState(null);
  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!branches) return <Loader />;
  const base = window.location.origin;

  return (
    <div>
      <PageHeader title="Wall Display" subtitle="Open a full-screen, auto-refreshing room status board for any branch." />
      {branches.length === 0 ? <EmptyState icon={Monitor} title="No branches" /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {branches.map((b) => (
            <div key={b.id} className="bg-white rounded-2xl border border-slate-200 p-5 sf-fade-up" data-testid={`wall-branch-${b.code}`}>
              <div className="w-11 h-11 rounded-xl bg-navy-900 text-white flex items-center justify-center"><Monitor size={20} /></div>
              <h3 className="font-display font-bold text-navy-900 mt-3 text-lg">{b.name}</h3>
              <p className="text-xs text-slate-400">{b.company_name}</p>
              <a href={`${base}/display/${b.public_id}`} target="_blank" rel="noreferrer">
                <Button className="mt-4 w-full bg-navy-900" data-testid={`open-wall-${b.code}`}><ExternalLink size={15} className="mr-1.5" /> Open Wall Display</Button>
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
